import React, { PureComponent } from 'react'
import Loader from '../../../Shared/Loader'
import {
  getBlueprint,
  getGiataProperty,
  getGiataPropertyImages,
  getImageGalleries,
  getLatestDescriptionForReview,
  getPermissionsByGiataId,
  getPropertyPublishInfo,
  getRooms,
  patchImageGalleries,
  uploadImage,
} from '../../../../api'
import DashboardWidget from '../../DashboardWidget'
import './style.scss'
import Alert from '../../../Shared/Alert'
import OpenContentLink from '../../Property/OpenContentLink'
import PropTypes from 'prop-types'
import FlowtifyInfo from '../../Property/FlowtifyInfo'
import ImageBrowser from '../../Property/ImageBrowser'
import Queue from '../../Property/ImageBrowser/queue'
import { uploadItemStatus } from '../../Property/ImageBrowser/constants'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../../Shared/Footer'
import RoomBrowser from '../../Property/Rooms/index'
import EditProperty from '../../Property/EditProperty'
import { withRouter } from '../../../Shared/Routing/withRouter'
import { roomActions } from '../../../../redux/actions/room'
import { withTranslation } from 'react-i18next'
import history from '../../../../history'
import activityTrackingService from '../../../../services/activityTrackingService'
import * as uuid from 'uuid'
import NavigationSidebar from '../../Property/NavigationSidebar'
import { isNavigationAllowed, propertyNavRoutes } from '../../Property/NavigationSidebar/NavigationHelper'
import ContentMonitor from '../ContentMonitor'
import NotificationCenter from '../../NotificationCenter'
import { isImageConfirmed } from '../../Property/ImageBrowser/utils'
import PropertyChecklist from '../../Property/CheckList'
import hotelierPropertyService from '../../../../services/hotelierPropertyService'
import { propertyActions } from '../../../../redux/actions/property'
import { notificationsActions } from '../../../../redux/actions/notifications'
import PropertyPublishedNoticeOverlay from '../../Property/PropertyPublishedNoticeOverlay'
import UnsavedChangesNoticeOverlay from '../../Property/EditProperty/UnsavedChangesNoticeOverlay'
import { trackingEvent } from '../../../../constants'
import ErrorNoticeOverlay from '../../ErrorNoticeOverlay'
import publishErrorImage from '../../../../assets/img/icons/info-retry.svg'
import GenericModal from '../../../Shared/GenericModal'
import { preferencesActions } from '../../../../redux/actions/preferences'
import {
  resetContradictionNotification,
  syncContradictionNotification
} from '../../../../services/contradictionNotifier'
import { resetPublishInfoNotifications, syncPublishInfoNotifications } from '../../../../services/publishInfoNotifier'
import { resetRoomImagesNotification, syncRoomImagesNotification } from '../../../../services/roomImagesNotifier'
import {
  resetLowResolutionImageNotification,
  syncLowResolutionImageNotification
} from '../../../../services/lowResolutionImageNotifier'

const ONE_DAY_MS = 24 * 60 * 60 * 1000

class PropertyPage extends PureComponent {

  state = {
    initialized: false,
    giataId: null,
    loading: false,
    property: null,
    permissions: null,
    rooms: null,
    roomAttributes: null,
    uploadQueue: [],
    selectedNavigation: null,
    isDirtyEditProperty: false,
    images: [],
    selectedImageIdsMap: {},
    promptUnsavedChanges: {
      show: false,
      onConfirmFunc: null
    },
    mainImage: null,
    propertyInfo: null,
    initialFactsheet: null,
    showPropertyPublishedLayer: false,
    error: false,
    latestDescriptionForReview: null,
    showRoomImageManagementWhatsNew: false,
    lastImageUploadDate: null,
    galleries: {
      property: {
        order: [],
        heroImage: null,
      },
      rooms: {},
    },
  }
  abortController = new AbortController()
  // init() stores the rooms (redux) before the galleries (state); without
  // batching that renders the new rooms against stale galleries in between, so
  // the rooms-without-images notification only syncs once both are in place.
  roomImagesNotificationReady = false

  componentDidMount () {
    const giataId = parseInt(this.props.router.params.id, 10)
    activityTrackingService.setGiataIdForEventsAndPageViews(giataId)
    const initState = { giataId }
    if (this.props.router.params.hasOwnProperty('subPage')) {
      initState.selectedNavigation = this.getSelectedNavigationValueFromSubPage(this.props.router.params.subPage)
    }
    this.setState(initState, () => {
      this.init(true)
      this.setState({ showRoomImageManagementWhatsNew: this.shouldShowRoomImageManagementWhatsNew() })
    })
  }

  shouldShowRoomImageManagementWhatsNew = () => {
    const userId = this.props.user.userId
    if (!userId) {
      return false
    }
    const preference = this.props.roomImageManagementWhatsNew?.[userId]
    if (!preference) {
      return true // never shown
    }
    if (preference.permanentlyDismissed) {
      return false
    }
    const { dismissedAt, skipCount } = preference
    if (skipCount >= 3) {
      return false
    }
    const timeSinceDismissed = Date.now() - dismissedAt
    if (skipCount === 1 && timeSinceDismissed >= ONE_DAY_MS) {
      return true
    }
    if (skipCount === 2 && timeSinceDismissed >= 3 * ONE_DAY_MS) {
      return true
    }
    return false
  }

  closePropertyFailedToPublishErrorOverlay = () => {
    this.props.setPropertyFailedToPublish(false)
  }

  /**
   * This returns an unblock handler that can be later used to unblock
   * It is currently called only when the isDirty bit is set to true
   */
  blockHistory () {
    return history.block(({ retry }) => {
      if (this.state.selectedNavigation === propertyNavRoutes.editProperty && this.state.isDirtyEditProperty) {
        this.setState({
          promptUnsavedChanges: {
            show: true,
            onConfirmFunc: () => {
              this.cancelPromptUnsavedChanges(() => {
                activityTrackingService.trackEvent(trackingEvent.discardEditPropertyChanges)
                this.unblockHistory()
                retry()
              })
            }
          }
        })
        return
      }
      this.unblockHistory()
      retry()
    })
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.router.params.subPage !== this.props.router.params.subPage) {
      this.setState({ selectedNavigation: this.getSelectedNavigationValueFromSubPage(this.props.router.params.subPage) })
    }
    if (prevProps.router.params.id !== this.props.router.params.id) {
      this.props.setPropertyHasUnpublishedChanges(false)
      // clear the previous property's contradiction notification so the new one
      // re-emits its own state once loaded.
      resetContradictionNotification()
      resetPublishInfoNotifications()
      this.roomImagesNotificationReady = false
      resetRoomImagesNotification()
      resetLowResolutionImageNotification()
      this.setState({ giataId: parseInt(this.props.router.params.id, 10) }, () => {
        this.init(false)
      })
      return
    }
    if (prevState.propertyInfo !== this.state.propertyInfo) {
      // propertyInfo carries the property's factsheet facts and is available on
      // every sub-view (and refreshed after a save), so drive contradiction
      // detection off it rather than the edit-only redux factsheet slice.
      syncContradictionNotification(this.state.propertyInfo?.factsheet?.facts ?? {})
      // a refreshed propertyInfo (after a save) means updatedAt moved; the
      // initial load is already covered by init().
      if (prevState.propertyInfo) {
        this.refreshPublishInfoNotifications()
      }
    }
    if (prevProps.propertyHasUnpublishedChanges !== this.props.propertyHasUnpublishedChanges) {
      // changes were made or published, so publishedAt/updatedAt moved.
      this.refreshPublishInfoNotifications()
    }
    if (
      this.roomImagesNotificationReady
      && (
        prevProps.room.rooms !== this.props.room.rooms ||
        prevState.galleries.rooms !== this.state.galleries.rooms
      )
    ) {
      // images were (un)assigned or rooms were added/removed.
      syncRoomImagesNotification(this.props.room.rooms, this.state.galleries)
    }
    if (
      prevState.images !== this.state.images ||
      prevState.galleries !== this.state.galleries ||
      prevProps.room.rooms !== this.props.room.rooms
    ) {
      // images were uploaded, deleted or moved between galleries, or rooms were
      // added/removed.
      syncLowResolutionImageNotification(this.state.images, this.state.galleries, this.props.room.rooms)
    }
    if (prevState.images !== this.state.images) {
      this.setState({
        lastImageUploadDate: this.calculateLastImageUploadDate()
      })
    }
    if (prevState.galleries.property !== this.state.galleries.property) {
      this.setState({
        mainImage: this.getPropertyMainImage(this.state.images)
      })
      this.clearInvalidSelectedImageIds()
    }
    if (prevProps.propertyHasUnpublishedChanges && !this.props.propertyHasUnpublishedChanges) {
      this.setState({
        showPropertyPublishedLayer: true
      })
    }
  }

  componentWillUnmount () {
    if (this.queue) {
      this.queue.clear()
    }
    this.props.setPropertyHasUnpublishedChanges(false)
    resetContradictionNotification()
    resetPublishInfoNotifications()
    this.roomImagesNotificationReady = false
    resetRoomImagesNotification()
    resetLowResolutionImageNotification()
    // the notification center's open state is global; close it on leave so it
    // doesn't carry over and reopen automatically on the next property.
    this.props.closeNotifications()
    this.abortController.abort()
  }

  getSelectedNavigationValueFromSubPage (subPage) {
    if (!Object.values(propertyNavRoutes).includes(subPage)) {
      return null
    }
    return subPage
  }

  onIsDirtyEditPropertyChange = (isDirty) => {
    this.unblockHistory && this.unblockHistory()
    this.unblockHistory = isDirty ? this.blockHistory() : null
    this.setState({ isDirtyEditProperty: isDirty }, () => {
      this.updatePropertyPublishBlockedState()
    })
  }

  onImagesChange = (images) => {
    this.setState({ images, mainImage: this.getPropertyMainImage(images) }, () => {
      this.updatePropertyPublishBlockedState()
    })
  }

  onImagesDeleted = (imageIds) => {
    const images = this.state.images.filter(image => !imageIds.includes(image.id))
    const selectedImageIdsMap = Object.assign({}, this.state.selectedImageIdsMap)
    imageIds.forEach((imageId) => {
      delete selectedImageIdsMap[imageId]
    })
    this.removeImagesFromGalleries(imageIds)
    this.setState({ images, selectedImageIdsMap, mainImage: this.getPropertyMainImage(images) }, () => {
      this.updatePropertyPublishBlockedState()
    })
  }

  onSelectedImageIdsMapChange = (selectedImageIdsMap) => {
    this.setState({ selectedImageIdsMap })
  }

  onUploadQueueChange = (uploadQueue) => {
    this.setState({ uploadQueue })
  }

  onUploadQueueImageRemove = (image) => {
    const index = this.state.uploadQueue.indexOf(image)
    if (index > -1) {
      let uploadQueueNew = [...this.state.uploadQueue]
      uploadQueueNew.splice(index, 1)
      this.onUploadQueueChange(uploadQueueNew)
    }
  }

  onRoomsChange = (rooms) => {
    const newRoomIds = new Set(rooms.map(r => r.id))
    const roomWasRemoved = this.props.room.rooms.some(room => !newRoomIds.has(room.id))
    this.props.putRooms(rooms)
    if (roomWasRemoved) {
      this.reloadAndReinitializeFactsheet()
      this.removeDeletedRoomsFromGalleries(newRoomIds)
    }
  }

  refreshPublishInfoNotifications () {
    getPropertyPublishInfo(this.state.giataId, this.abortController)
      .then(syncPublishInfoNotifications)
      .catch(() => {})
  }

  init (initial) {
    if (!initial) {
      this.abortController.abort()
      this.abortController = new AbortController()
    }
    this.roomImagesNotificationReady = false
    this.setState({ initialized: false, loading: true }, async () => {
      const concurrentApiRequests = []
      let request = getGiataProperty(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getBlueprint(this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getRooms(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getPermissionsByGiataId(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getGiataPropertyImages(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getImageGalleries(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)

      let concurrentApiResponses
      try {
        concurrentApiResponses = await Promise.all(concurrentApiRequests)
      } catch (e) {
        if (e.message === 'NOT_AUTHORIZED') {
          this.props.router.navigate('/errors/not-authorized')
        }
        this.setState({ loading: false, error: true })
        return
      }
      const roomAttributes = concurrentApiResponses[1]
      const rooms = concurrentApiResponses[2]
      const property = concurrentApiResponses[0]
      const permissions = concurrentApiResponses[3].permissions
      const images = concurrentApiResponses[4]
      const imageGalleries = concurrentApiResponses[5] ?? {}
      imageGalleries.property ??= {
        order: []
      }
      imageGalleries.rooms ??= {}

      this.props.putRoomAttributes(this.buildRoomAttributesMap(roomAttributes))
      this.props.putRooms(rooms)
      this.props.setPropertyPermissions(permissions)

      const editPropertyAllowed = isNavigationAllowed(propertyNavRoutes.editProperty, permissions)

      this.queue = new Queue(1)
      const newState = {
        initialized: !editPropertyAllowed,
        loading: editPropertyAllowed,
        property,
        permissions,
        images,
        mainImage: this.getPropertyMainImage(images),
        uploadQueue: [],
        isDirtyEditProperty: false,
        galleries: imageGalleries,
      }
      this.props.refreshPropertyPublishStatus(this.state.giataId)
      this.refreshPublishInfoNotifications()
      this.setState(newState, () => {
        this.roomImagesNotificationReady = true
        syncRoomImagesNotification(this.props.room.rooms, this.state.galleries)
        if (!isNavigationAllowed(this.state.selectedNavigation, permissions)) {
          this.changeNavigation(propertyNavRoutes.editRooms, true)
        }
        this.updatePropertyPublishBlockedState()
      })
      if (editPropertyAllowed) {
        // load property info
        hotelierPropertyService.getGiataHotelierProperty(this.state.giataId, this.abortController)
          .then(res => {
            this.setState({
              propertyInfo: res.giataHotelierProperty,
              initialFactsheet: res.initialFactsheet,
              loading: false,
              initialized: true,
            })
          })
          .catch(() => {
            this.setState({ loading: false, error: true })
          })
        getLatestDescriptionForReview(this.state.giataId, this.abortController)
          .then(res => {
            this.setState({
              latestDescriptionForReview: res,
            })
          })
          .catch(() => {})
      }
    })
  }

  updatePropertyPublishBlockedState () {
    const hasUnconfirmedImages = this.getUnConfirmedImagesCount() > 0
    if (hasUnconfirmedImages !== this.props.propertyPublishBlockedUnconfirmedImages) {
      this.props.setPropertyPublishBlockedUnconfirmedImages(hasUnconfirmedImages)
    }
    const hasNoPropertyImages = this.state.galleries.property.order.length === 0
    if (hasNoPropertyImages !== this.props.propertyPublishBlockedNoPropertyImages) {
      this.props.setPropertyPublishBlockedNoPropertyImages(hasNoPropertyImages)
    }
  }

  buildRoomAttributesMap (roomAttributes) {
    let roomCategory = {}
    let roomName = {}
    let roomType = {}
    let roomView = {}
    roomAttributes.roomCategory.forEach((v) => {
      roomCategory[v.id] = v
    })
    roomAttributes.roomName.forEach((v) => {
      roomName[v.id] = v
    })
    roomAttributes.roomType.forEach((v) => {
      roomType[v.id] = v
    })
    roomAttributes.roomView.forEach((v) => {
      roomView[v.id] = v
    })
    return {
      roomCategory,
      roomName,
      roomType,
      roomView,
    }
  }

  getIndexOfImageInUploadQueue (image, uploadQueue) {
    return uploadQueue.findIndex(item => item.id === image.id)
  }

  /**
   * Updates the progress of an upload in the queue.
   * @param {Object} imageInUploadQueue - The image object in the upload queue.
   * @param {ProgressEvent} event - The progress event object.
   */
  updateUploadProgress = (imageInUploadQueue, event) => {
    this.setState((state) => {
      const index = this.getIndexOfImageInUploadQueue(imageInUploadQueue, state.uploadQueue)
      if (index === -1) {
        return state
      }

      const uploadQueueNew = [...state.uploadQueue]
      uploadQueueNew[index] = {
        ...uploadQueueNew[index],
        progress: Math.round((100 * event.loaded) / event.total),
      }

      return {
        uploadQueue: uploadQueueNew,
      }
    })
  }

  updateUploadStatus (imageInUploadQueue, status, cancelTokenSource) {
    this.setState((state) => {
      const index = this.getIndexOfImageInUploadQueue(imageInUploadQueue, state.uploadQueue)
      if (index === -1) {
        return state
      }

      const uploadQueueNew = [...state.uploadQueue]
      uploadQueueNew[index] = {
        ...uploadQueueNew[index],
        status: status,
        cancel: cancelTokenSource.cancel,
      }

      return {
        uploadQueue: uploadQueueNew,
      }
    })
  }

  handleUploadError (imageInUploadQueue, error) {
    this.setState((state) => {
      const index = this.getIndexOfImageInUploadQueue(imageInUploadQueue, state.uploadQueue)
      if (index === -1) {
        return state
      }

      const uploadQueueNew = [...state.uploadQueue]
      let status = uploadItemStatus.error
      if (
        (error.hasOwnProperty('status') && error.status === 406)
        || (error.isAxiosError === true && error?.response?.status === 406)
      ) {
        status = uploadItemStatus.errorProcessImage
      } else if (
        (error.hasOwnProperty('status') && error.status === 409)
        || (error.isAxiosError === true && error?.response?.status === 409)
      ) {
        status = uploadItemStatus.errorImageAlreadyExists
      }
      uploadQueueNew[index] = {
        ...uploadQueueNew[index],
        status
      }
      return {
        uploadQueue: uploadQueueNew,
      }
    })
  }

  handleUploadSuccess (imageInUploadQueue, responseData) {
    this.setState((state) => {
      const index = this.getIndexOfImageInUploadQueue(imageInUploadQueue, state.uploadQueue)
      if (index === -1) {
        return state
      }
      const galleries = structuredClone(state.galleries)
      const uploadQueueNew = [...state.uploadQueue]
      if (uploadQueueNew[index].progress !== 100 || !responseData.hasOwnProperty('url')) {
        uploadQueueNew[index] = {
          ...uploadQueueNew[index],
          status: uploadItemStatus.error
        }
      } else {
        let imagesNew = [...state.images]
        const existingImageIndex = imagesNew.findIndex(image => image.id === responseData.id)
        if (existingImageIndex !== -1) {
          imagesNew[existingImageIndex] = responseData
        } else {
          imagesNew.push(responseData)
          galleries.property ??= {}
          galleries.property.order ??= []
          galleries.property.order.push(responseData.id)
        }
        if (imageInUploadQueue.roomId) {
          galleries.rooms ??= {}
          galleries.rooms[imageInUploadQueue.roomId] ??= {}
          galleries.rooms[imageInUploadQueue.roomId].order ??= []
          if (!!galleries.rooms[imageInUploadQueue.roomId].order.find(id => id === responseData.id) === false) {
            galleries.rooms[imageInUploadQueue.roomId].order.push(responseData.id)
          }
        }
        uploadQueueNew.splice(index, 1)
        return {
          images: imagesNew,
          uploadQueue: uploadQueueNew,
          galleries: galleries,
        }
      }

      return {
        uploadQueue: uploadQueueNew,
      }
    }, () => {
      this.updatePropertyPublishBlockedState()
    })
  }

  onUploadFiles = (files, roomId = null) => {
    let uploadQueue = [...this.state.uploadQueue]

    files.forEach((file) => {
      const uuidV4 = uuid.v4()
      file.id = uuidV4
      const previewUrl = URL.createObjectURL(file)
      const imageInUploadQueue = {
        id: uuidV4,
        src: previewUrl,
        name: file.name,
        status: uploadItemStatus.waiting,
        file: file,
        roomId,
        progress: 0,
      }
      uploadQueue.push(imageInUploadQueue)
    })

    this.setState({ uploadQueue }, () => {
      files.forEach((file) => {
        const imageInUploadQueue = this.state.uploadQueue.find(image => image.id === file.id)
        if (!imageInUploadQueue) {
          console.error(`Image with id ${file.id} not found in uploadQueue`)
          return
        }
        const taskUploadImage = async () => {
          const { promise, cancelTokenSource } = uploadImage(
            this.state.property.giataId,
            imageInUploadQueue.file,
            imageInUploadQueue.roomId,
            (event) => {
              this.updateUploadProgress(imageInUploadQueue, event)
            }
          )

          try {
            this.updateUploadStatus(imageInUploadQueue, uploadItemStatus.uploading, cancelTokenSource)
            const response = await promise
            this.handleUploadSuccess(imageInUploadQueue, response.data)
          } catch (e) {
            this.handleUploadError(imageInUploadQueue, e)
          }
        }

        this.queue.enqueue(taskUploadImage).catch(console.error)
      })
    })
  }

  cancelPromptUnsavedChanges = (cb) => {
    this.setState(
      {
        promptUnsavedChanges: {
          show: false,
          onConfirmFunc: null
        }
      },
      typeof (cb) === 'function' ? cb : null
    )
  }

  onSelectedNavBarChange = (route) => {
    history.push(route)
  }

  changeNavigation (selectedNavigation, replace = false) {
    if (Object.values(propertyNavRoutes).includes(selectedNavigation)) {
      const path = '/property/' + this.state.giataId + '/' + selectedNavigation
      if (replace) {
        history.replace(path)
      }
      history.push(path)
    }
  }

  showImageBrowserSaveButton = () => {
    if (/^giata-\d+-supplier-\d+@giata.de$/.test(this.props.user.user)) {
      return false
    }
    return true
  }

  calculateLastImageUploadDate = () => {
    if (this.state.images.length === 0) {
      return null
    }

    const validDates = this.state.images
      .map(image => image.createdAt ? new Date(image.createdAt) : null)
      .filter(date => date && !isNaN(date.getTime()))

    return validDates.length === 0 ? null : new Date(Math.max(...validDates))
  }

  getConfirmedImagesCount = () => {
    return this.state.images.filter(image => isImageConfirmed(image)).length
  }

  getConfirmedRoomImagesCount = () => {
    const roomImages = new Set()
    Object.keys(this.state.galleries.rooms ?? {}).forEach(roomId => {
      const roomImagesInRoom = this.state.galleries.rooms[roomId]?.order ?? []
      roomImagesInRoom.forEach(imageId => roomImages.add(imageId))
    })
    return this.state.images.filter(image => isImageConfirmed(image) && roomImages.has(image.id)).length
  }

  getConfirmedPropertyImagesCount = () => {
    const propertyImageIds = new Set(this.state.galleries.property.order ?? [])
    return this.state.images.filter(image => isImageConfirmed(image) && propertyImageIds.has(image.id)).length
  }

  getUnConfirmedImagesCount = () => {
    return this.state.images.filter(image => !isImageConfirmed(image)).length
  }

  getPropertyMainImage = (images = []) => {
    const heroImage = images.find(i => i.id === this.state.galleries.property.heroImage)
    if (heroImage) {
      return heroImage.displayUrl
    }
    const firstImageIdInPropertyOrder = this.state.galleries?.property?.order?.[0] ?? null
    if (!firstImageIdInPropertyOrder) {
      return images[0]?.displayUrl ?? null
    }
    const firstImage = images.find(i => i.id === firstImageIdInPropertyOrder)
    return firstImage?.displayUrl ?? images[0]?.displayUrl ?? null
  }

  reloadAndReinitializeFactsheet = () => {
    this.setState({ loading: true, initialized: false }, () => {
      hotelierPropertyService.getGiataHotelierProperty(this.state.giataId, this.abortController)
        .then(res => {
          this.setState({
            propertyInfo: res.giataHotelierProperty,
            initialFactsheet: res.initialFactsheet,
            loading: false,
            initialized: true,
          })
        })
        .catch(() => {
          this.setState({ loading: false, error: true })
        })
    })
  }

  removeDeletedRoomsFromGalleries = (remainingRoomIdsSet) => {
    const roomGalleries = { ...(this.state.galleries.rooms ?? {}) }
    if (Object.keys(roomGalleries).length === 0) {
      return
    }
    let hasChanges = false

    Object.keys(roomGalleries).forEach(roomId => {
      if (!remainingRoomIdsSet.has(roomId)) {
        delete roomGalleries[roomId]
        hasChanges = true
      }
    })

    if (hasChanges) {
      this.setState({
        galleries: {
          ...this.state.galleries,
          rooms: roomGalleries,
        }
      })
    }
  }

  handleGalleriesChange = (patch, localOnly = false) => {
    if (localOnly) {
      this.setState({ galleries: { ...this.state.galleries, ...patch } })
      return Promise.resolve()
    }
    const { fetchPromise } = patchImageGalleries(this.state.giataId, patch)
    return fetchPromise.then(res => {
      this.setState({ galleries: res })
    })
  }

  getNavigationContent () {
    let navigationContent = null
    if (this.state.selectedNavigation === propertyNavRoutes.dashboard) {
      navigationContent =
        <DashboardWidget trackPageViewName={'Dashboard'} giataId={this.state.giataId} widget={'scores'}
                         permissions={this.state.permissions}
                         confirmedImagesCount={this.getConfirmedImagesCount()}/>
    } else if (this.state.selectedNavigation === propertyNavRoutes.distribution) {
      navigationContent =
        <DashboardWidget
          trackPageViewName={'Sales Channels'}
          giataId={this.state.giataId}
          widget={'distribution'}
          permissions={this.state.permissions}
          propertyImage={this.state.mainImage}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.tourOperators) {
      navigationContent =
        <DashboardWidget
          trackPageViewName={'Tour Operators'}
          giataId={this.state.giataId} widget={'tourOperators'}
          permissions={this.state.permissions}
          propertyImage={this.state.mainImage}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.compare) {
      navigationContent =
        <DashboardWidget
          trackPageViewName={'Compare Hotels'}
          giataId={this.state.giataId}
          widget={'compare'}
          permissions={this.state.permissions}
          propertyImage={this.state.mainImage}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.editProperty) {
      navigationContent = this.state.propertyInfo === null
        ? <Loader size={32}/>
        : <EditProperty
          giataId={this.state.giataId}
          permissions={this.state.permissions}
          onIsDirtyChange={this.onIsDirtyEditPropertyChange}
          propertyInfo={this.state.propertyInfo}
          initialFactsheet={this.state.initialFactsheet}
          updatePropertyInfo={propertyInfo => {
            this.setState({
              propertyInfo
            })
          }}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.editRooms) {
      navigationContent =
        <RoomBrowser property={this.state.property}
                     rooms={this.props.room.rooms}
                     images={this.state.images}
                     roomAttributes={this.props.room.roomAttributes}
                     onRoomsChange={this.onRoomsChange}
                     onImagesChange={this.onImagesChange}
                     uploadQueue={this.state.uploadQueue}
                     onUploadFiles={this.onUploadFiles}
                     onUploadQueueImageRemove={this.onUploadQueueImageRemove}
                     galleries={this.state.galleries}
                     onGalleriesChange={this.handleGalleriesChange}
                     onImagesDeleted={this.onImagesDeleted}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.ocl) {
      navigationContent = <OpenContentLink
        property={this.state.property}
        descriptionForReview={this.state.latestDescriptionForReview}
      />
    } else if (this.state.selectedNavigation === propertyNavRoutes.staySafe) {
      navigationContent = <FlowtifyInfo permissions={this.state.permissions} giataId={this.state.property.giataId}/>
    } else if (this.state.selectedNavigation === propertyNavRoutes.images) {
      navigationContent =
        <ImageBrowser images={this.state.images} property={this.state.property}
                      onImagesChange={this.onImagesChange}
                      user={this.props.user}
                      rooms={this.props.room.rooms}
                      showSaveButton={this.showImageBrowserSaveButton()}
                      roomAttributes={this.props.room.roomAttributes}
                      permissions={this.state.permissions}
                      uploadQueue={this.state.uploadQueue}
                      onUploadFiles={this.onUploadFiles}
                      onUploadQueueChange={this.onUploadQueueChange}
                      selectedImageIdsMap={this.state.selectedImageIdsMap}
                      onSelectedImageIdsMapChange={this.onSelectedImageIdsMapChange}
                      galleries={this.state.galleries}
                      onGalleriesChange={this.handleGalleriesChange}
                      onImagesDeleted={this.onImagesDeleted}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.contentMonitor) {
      navigationContent = <ContentMonitor
        property={this.state.property}
        confirmedImagesCount={this.getConfirmedImagesCount()}
        confirmedRoomImagesCount={this.getConfirmedRoomImagesCount()}
        confirmedPropertyImagesCount={this.getConfirmedPropertyImagesCount()}
        factsCount={Object.keys(this.state.propertyInfo?.factsheet?.facts ?? {}).length}
        roomsCount={this.props?.room?.rooms?.length ?? 0}
        lastImageUploadDate={this.state.lastImageUploadDate}
      />
    }
    return navigationContent
  }

  render () {
    const { t } = this.props

    return (
      <div className="default-layout main-wrapper">
        <Header property={this.state.property}/>
        <NotificationCenter
          giataId={this.state.giataId}
          publishAllowed={!this.state.isDirtyEditProperty}
        />
        <main>
          <NavigationSidebar
            property={this.state.property}
            permissions={this.state.permissions}
            onNavigate={this.onSelectedNavBarChange}
            showNewBadgeOnOcl={!!this.state.latestDescriptionForReview}
          />
          <div className="property-page">
            {this.state.loading && <Loader size={16}/>}
            {this.state.error && <Alert type={'danger'}>Error occurred</Alert>}
            {
              this.props.propertyFailedToPublish && <ErrorNoticeOverlay
                onClose={this.closePropertyFailedToPublishErrorOverlay}
                header={this.props.t('ERROR_NOTICE_PROPERTY_PUBLISH_HEADER')}
                icon={publishErrorImage}
              />
            }
            {
              this.state.initialized === true ? <React.Fragment>
                  <div className="property-page-nav-content">
                    {this.getNavigationContent()}
                  </div>
                  {
                    this.state.promptUnsavedChanges.show && <UnsavedChangesNoticeOverlay
                      onCancel={() => {
                        this.cancelPromptUnsavedChanges()
                      }}
                      onConfirm={this.state.promptUnsavedChanges.onConfirmFunc}
                    />
                  }
                  <PropertyChecklist
                    ready={this.state.initialized}
                    property={this.state.propertyInfo}
                    images={this.state.images}
                    rooms={this.props.room.rooms}
                    includeEditPropertyItems={isNavigationAllowed(propertyNavRoutes.editProperty, this.state.permissions)}
                    galleries={this.state.galleries}
                  />
                  {this.state.showPropertyPublishedLayer && <PropertyPublishedNoticeOverlay
                    giataId={this.state.giataId}
                    onClose={() => {
                      this.setState({ showPropertyPublishedLayer: false })
                    }}
                  />}
                  <GenericModal
                    id={'room-image-management-whats-new'}
                    show={this.state.showRoomImageManagementWhatsNew && !this.state.isDirtyEditProperty}
                    onClose={() => {
                      this.setState({ showRoomImageManagementWhatsNew: false })
                      this.props.dismissRoomImageManagementWhatsNew(this.props.user.userId)
                      activityTrackingService.trackEvent(trackingEvent.dismissRoomMgmtWhatsNew)
                    }}
                    title={t('propertyPage.roomImageManagementWhatsNew.title')}
                    body={
                      <div className="room-image-management-whats-new-body">
                        <p>{t('propertyPage.roomImageManagementWhatsNew.intro')}</p>
                        <br/>
                        <h4>{t('propertyPage.roomImageManagementWhatsNew.whatsNew.header')}</h4>
                        <ul>
                          <li>{t('propertyPage.roomImageManagementWhatsNew.whatsNew.item1')}</li>
                          <li>{t('propertyPage.roomImageManagementWhatsNew.whatsNew.item2')}</li>
                          <li>{t('propertyPage.roomImageManagementWhatsNew.whatsNew.item3')}</li>
                        </ul>
                        <br/>
                        <h4>{t('propertyPage.roomImageManagementWhatsNew.pleaseNote.header')}</h4>
                        <ul>
                          <li>{t('propertyPage.roomImageManagementWhatsNew.pleaseNote.item1')}</li>
                          <li>{t('propertyPage.roomImageManagementWhatsNew.pleaseNote.item2')}</li>
                        </ul>
                      </div>
                    }
                    actions={[
                      {
                        label: t('propertyPage.roomImageManagementWhatsNew.actions.gotIt'),
                        onClick: () => {
                          this.setState({ showRoomImageManagementWhatsNew: false })
                          this.props.dismissRoomImageManagementWhatsNew(this.props.user.userId)
                          activityTrackingService.trackEvent(trackingEvent.dismissRoomMgmtWhatsNew)
                        },
                        variant: 'neutral',
                        minWidth: '160px',
                      },
                      {
                        label: t('propertyPage.roomImageManagementWhatsNew.actions.goToEditRooms'),
                        onClick: () => {
                          this.setState({ showRoomImageManagementWhatsNew: false }, () => {
                            this.changeNavigation(propertyNavRoutes.editRooms)
                          })
                          this.props.dismissRoomImageManagementWhatsNew(this.props.user.userId)
                          activityTrackingService.trackEvent(trackingEvent.gotoEditRoomsFromRoomMgmtWhatsNew)
                        },
                        variant: 'primary',
                        minWidth: '160px',
                      },
                    ]}
                  />
                </React.Fragment>
                : null
            }
          </div>
        </main>
        <Footer/>
      </div>
    )
  }

  removeImagesFromGalleries (imageIds) {
    const galleries = structuredClone(this.state.galleries)
    const imageIdsSet = new Set(imageIds)
    let hasChanges = false

    if (galleries.property?.order) {
      const filteredPropertyOrder = galleries.property.order.filter(id => !imageIdsSet.has(id))
      if (filteredPropertyOrder.length !== galleries.property.order.length) {
        galleries.property.order = filteredPropertyOrder
        hasChanges = true
      }
    }

    if (galleries.rooms) {
      Object.keys(galleries.rooms).forEach(roomId => {
        if (galleries.rooms[roomId]?.order) {
          const filteredRoomOrder = galleries.rooms[roomId].order.filter(id => !imageIdsSet.has(id))
          if (filteredRoomOrder.length !== galleries.rooms[roomId].order.length) {
            galleries.rooms[roomId].order = filteredRoomOrder
            hasChanges = true
          }
        }
      })
    }

    if (hasChanges) {
      this.setState({ galleries })
    }
  }

  clearInvalidSelectedImageIds () {
    const propertyImageIdsMap = new Map(this.state.galleries.property.order.map(id => [id, true]))
    const selectedImageIds = Object.keys(this.state.selectedImageIdsMap)
    const newSelectedImageIdsMap = {}
    selectedImageIds.forEach(id => {
      if (propertyImageIdsMap.has(id)) {
        newSelectedImageIdsMap[id] = true
      }
    })
    this.setState({ selectedImageIdsMap: newSelectedImageIdsMap })
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    room: state.room,
    propertyHasUnpublishedChanges: state.property.hasUnpublishedChanges,
    propertyFailedToPublish: state.property.failedToPublish,
    propertyPublishBlockedUnconfirmedImages: state.property.isPublishBlockedDueToUnconfirmedImages,
    propertyPublishBlockedNoPropertyImages: state.property.isPublishBlockedDueToNoPropertyImages,
    roomImageManagementWhatsNew: state.preferences.roomImageManagementWhatsNew,
  }
}

const mapDispatchToProps = {
  putRooms: roomActions.putRooms,
  putRoomAttributes: roomActions.putRoomAttributes,
  refreshPropertyPublishStatus: propertyActions.refreshPublishStatus,
  setPropertyHasUnpublishedChanges: propertyActions.setHasUnpublishedChanges,
  setPropertyPublishBlockedUnconfirmedImages: propertyActions.setIsPublishBlockedDueToUnconfirmedImages,
  setPropertyPublishBlockedNoPropertyImages: propertyActions.setIsPublishBlockedDueToNoPropertyImages,
  setPropertyFailedToPublish: propertyActions.setFailedToPublish,
  dismissRoomImageManagementWhatsNew: preferencesActions.dismissRoomImageManagementWhatsNew,
  setPropertyPermissions: propertyActions.setPermissions,
  closeNotifications: notificationsActions.close,
}

PropertyPage.propTypes = {
  user: PropTypes.object,
  router: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(PropertyPage)))
